/**
 * @module Section-Home2-Slider
 */

import { NavLink } from "react-router-dom";
import { navUrl, publicUrlFor } from "../../../../globals/common-functions";
import { route } from "../../../../globals/constants";
import { TypeSectionSlider } from "../../../@types/sectionTypes";

/**
 * Content/Image Sliding Area
 * @param props : Data supplied to display slider
 * @returns Content slider markup template for home 2
 */
const SectionHome2Slider = (
    props: {
        _slider: TypeSectionSlider
    }
) => {
    const { _slider } = props;
    return (
        <div className="av-bnr-2-wrap-outer home-2-slider swi-dotts">
            {/* swiper slides */}
            <div className="swiper-wrapper">
                {
                    _slider.slides.map((_item, _index) => {
                        return (
                            <div key={_index} className="av-bnr-2-wrap swiper-slide overlay-overlay" style={{ backgroundImage: `url(${publicUrlFor(_item.image)})` }}>
                                <div className="sx-bg-overlay opacity-0 sx-bg-primary" />
                                <div className="container">
                                    <div className="av-bnr-2-content">
                                        <h2 className="av-bnr-2-large-title">{_item.title}</h2>
                                        <div className="av-bnr-2-info">{_item.subtitle}</div>
                                        <div className="av-bnr-readmore">
                                            <a href={"/#contactus"} className="site-button">
                                                Lets Start now
                                                {/* <i className="fa fa-plus" /> */}
                                            </a>
                                            <a href={"/#about"} className="site-button outline-white">
                                                Learn More
                                                {/* <i className="fa fa-plus" /> */}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            {/* !swiper slides */}
            {/* <div className="swiper-pagination" /> */}
            {/* <div className="swiper-button-wrap">
                <div className="swiper-button-next" />
                <div className="swiper-button-prev" />
            </div> */}
        </div>
    )
}
export default SectionHome2Slider;